import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import { getAvatarDetails, testFeaturesExist } from '../utils';

const Holder = styled.div`
  position: relative;
  margin-bottom: 4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  > * { transition: 150ms opacity ease-in; }
`;

const ImageHolder = styled.div`
  position: absolute;
  bottom: -4rem;
  right: -4px;
  width: 14rem;
  height: 0;
  padding-bottom: calc(14rem - 8px);
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid ${props => props.theme.colours.white};
  background-color: ${props => props.theme.colours.lightGrey2};
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;

const EmptyHolder = styled.div`
  width: 100%;
  padding: 6rem;
  margin-bottom: 4rem;
  text-align: center;
  background-color: ${props => props.theme.colours.lightGrey2};
`;

function YourAvatarHolder({features, currentAvatar}) {

  const [error, setError] = useState(true);
  const avatarDetails = getAvatarDetails(currentAvatar);

  useEffect(() => {
    if( testFeaturesExist(features) ) { setError(false) }
  }, [features]);

  if( error ) {
    return (
      <EmptyHolder>
        <h2>Oops! Something went wrong and there's no avatar to show.</h2>
        <p>Perhaps <Link to='/'>start again</Link>?</p>
      </EmptyHolder>
    );
  }

  return (
    <Holder>
      <Avatar
        currentAvatar={currentAvatar}
        features={features}/>
      <ImageHolder>
        <img src={avatarDetails.image} alt={avatarDetails.name}/>
      </ImageHolder>
    </Holder>
  )
}

YourAvatarHolder.propTypes = {
  currentAvatar: PropTypes.string.isRequired,
  features: PropTypes.object.isRequired,
};

export default withTheme( YourAvatarHolder );
